export const styles = {
  description: {
    color: "events.lightBlack",
    paddingRight: "32px",
  },
  helpLinkButton: {
    marginTop: "16px",
    textDecoration: "none",
    "& > :first-child": {
      fontSize: "16px",
      fontWeight: 700,
      lineHeight: "20.83px",
      color: "events.blueSecondary",
    },
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    gap: "10px",
    padding: "20px",
  },
};
